<div class="flex-container gap-16" style="height: 100%">
  <vl-widget-title [text]="'dashboard_ui.ofs_en_cours' | trans" [widget]="widget()" [draggable]="true">
    <ng-content class="drag-handler" select='.drag-handler'></ng-content>
  </vl-widget-title>

  @if (metadata().loading) {
    <div class="h100 overflow-hidden">
      <ngx-skeleton-loader count="20" [theme]="{'background-color': 'var(--color-on-disabled)'}"/>
    </div>
  } @else {
    <div class="flex-col gap-4 overflow-scroll fade-in pl-md-32 gap-16">
      @for (item of ofs(); track item.of.id) {
        <div class="flex-row align-center gap-8">
          <vl-icon-of-etat [etat]="item.of.etat"></vl-icon-of-etat>
          <div class="flex-col">
            <div class="flex-row gap-8 align-end">
              <span class="body-2 on-background-alt">{{item.of.numero}}</span>
              <span class="caption on-disabled">{{item.ligne}}</span>
            </div>
            <div class="flex-row gap-8 align-end">
              <span class="caption on-background-alt">{{item.article.denomination}}</span>
              <span class="caption on-disabled">{{item.article.code}}</span>
            </div>
          </div>
        </div>
      } @empty {
        <span class="caption on-disabled">{{ 'list.empty' | trans }}</span>
      }
    </div>
  }
</div>
